import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const PRODUCTION = process.env.REACT_APP_PRODUCTION;
const BASE_URL =
  PRODUCTION === "true"
    ? process.env.REACT_APP_APIURL_LIVE
    : process.env.REACT_APP_STAGING_APIURL;

const initialState = {
  status: "idle",
  error: null,
  message: null,
  tokenKey: "",
};

export const getAuthToken = createAsyncThunk(
  "token/getAuthToken",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}get-token`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const authTokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {},
  extraReducers: {
    [getAuthToken.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getAuthToken.fulfilled]: (state, action) => {
      state.status = "succeeded";
      localStorage.setItem("authToken", action.payload.data.token);
    },
    [getAuthToken.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default authTokenSlice.reducer;
